var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEditarLista01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#030104;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 16.7,
    className: "st0",
    width: 13.6,
    height: 2.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.1,30.3H4.5c-0.7,0-1.4-0.6-1.4-1.4v-23h27.1v11.4c0.6-0.3,1.2-0.4,1.8-0.4c0.3,0,0.6,0,0.9,0.1V4.5 c0-2.2-1.8-4.1-4.1-4.1H4.5c-2.2,0-4.1,1.8-4.1,4.1v24.4c0,2.2,1.8,4.1,4.1,4.1h12.8L18.1,30.3z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7,
    y: 11.3,
    className: "st0",
    width: 13.6,
    height: 2.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "12.7,24.8 22.3,24.8 25,22.1 12.7,22.1  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 16.7,
    className: "st0",
    width: 2.7,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 11.3,
    className: "st0",
    width: 2.7,
    height: 2.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.2,
    y: 22.1,
    className: "st0",
    width: 2.7,
    height: 2.7
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M35.1,22L33.1,20c-0.6-0.6-1.5-0.6-2,0l-1.7,1.7l4.1,4.1l1.7-1.7C35.7,23.5,35.7,22.6,35.1,22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M21.3,29.6c-0.1,0.1-0.2,0.2-0.2,0.3l-1.4,4.9c-0.1,0.2,0,0.4,0.2,0.6c0.1,0.1,0.3,0.2,0.4,0.2 c0.1,0,0.1,0,0.2,0l4.9-1.4c0.1,0,0.2-0.1,0.3-0.2l6.7-6.7l-4.3-4.3L21.3,29.6z M21.9,33.8l-0.6-0.6l0.8-2.8l2.1,0.4l0.4,2.1 L21.9,33.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEditarLista01);
export default __webpack_public_path__ + "static/media/ico-editar-lista-01.335747c08357a821862b0d54e62c26ed.svg";
export { ForwardRef as ReactComponent };